import { action, makeObservable, observable } from "mobx";

import { fetchConfigFileWithDefault, applyEnvVars } from "../fetchConfig";

const DEFAULT_ENV_VARS = {
  REACT_APP_NO_MODEL: "false",
  REACT_APP_SYNC_UPLOADER: "true",
  REACT_APP_INITIAL_CONFIDENCE: "0.8",
  REACT_APP_INITIAL_TRANSPOSED: "false",
  REACT_APP_BACKEND_URL: "http://localhost:8000",
  REACT_APP_MULTIFILE_UPLOAD: "true",
  REACT_APP_MULTIFILE_SINGLE_REQUEST: "false",
  REACT_APP_HEADER_AND_SIDEBAR: "false",
  REACT_APP_LOGIN_REQUIRED: "false",
  REACT_APP_SHOW_AWS_MARKETPLACE: "true",
};

class EnvVarStore {
  noModel =
    process.env.REACT_APP_NO_MODEL || DEFAULT_ENV_VARS.REACT_APP_NO_MODEL;
  syncUploader =
    process.env.REACT_APP_SYNC_UPLOADER ||
    DEFAULT_ENV_VARS.REACT_APP_SYNC_UPLOADER;
  initialConfidence = parseFloat(
    process.env.REACT_APP_INITIAL_CONFIDENCE ||
      DEFAULT_ENV_VARS.REACT_APP_INITIAL_CONFIDENCE,
  );
  initialTransposed =
    process.env.REACT_APP_INITIAL_TRANSPOSED ||
    DEFAULT_ENV_VARS.REACT_APP_INITIAL_TRANSPOSED;
  backendUrl =
    process.env.REACT_APP_BACKEND_URL || DEFAULT_ENV_VARS.REACT_APP_BACKEND_URL;
  multifileUpload =
    process.env.REACT_APP_MULTIFILE_UPLOAD ||
    DEFAULT_ENV_VARS.REACT_APP_MULTIFILE_UPLOAD;
  multifileSingleRequest =
    process.env.REACT_APP_MULTIFILE_SINGLE_REQUEST ||
    DEFAULT_ENV_VARS.REACT_APP_MULTIFILE_SINGLE_REQUEST;

  headerAndSidebar =
    process.env.REACT_APP_HEADER_AND_SIDEBAR ||
    DEFAULT_ENV_VARS.REACT_APP_HEADER_AND_SIDEBAR;
  loginRequired =
    process.env.REACT_APP_LOGIN_REQUIRED ||
    DEFAULT_ENV_VARS.REACT_APP_LOGIN_REQUIRED;
  showAWSMarketplace =
    process.env.REACT_APP_SHOW_AWS_MARKETPLACE ||
    DEFAULT_ENV_VARS.REACT_APP_SHOW_AWS_MARKETPLACE;

  setNoModel(value: string) {
    this.noModel = value;
  }
  setSyncUploader(value: string) {
    this.syncUploader = value;
  }
  setInitialConfidence(value: number) {
    this.initialConfidence = value;
  }
  setInitialTransposed(value: string) {
    this.initialTransposed = value;
  }
  setBackendUrl(value: string) {
    this.backendUrl = value;
  }
  setMultifileUpload(value: string) {
    this.multifileUpload = value;
  }
  setMultifileSingleRequest(value: string) {
    this.multifileSingleRequest = value;
  }
  setHeaderAndSidebar(value: string) {
    this.headerAndSidebar = value;
  }
  setLoginRequired(value: string) {
    this.loginRequired = value;
  }
  setShowAWSMarketplace(value: string) {
    this.showAWSMarketplace = value;
  }

  async fetchEnvVars() {
    const serverUrl = process.env.REACT_APP_SERVER_URL;
    const envVars = await fetchConfigFileWithDefault(
      "EnvVars.json",
      DEFAULT_ENV_VARS,
      serverUrl,
    );

    // 환경 변수 값들을 Store에 설정
    const setters = {
      REACT_APP_NO_MODEL: this.setNoModel,
      REACT_APP_SYNC_UPLOADER: this.setSyncUploader,
      REACT_APP_INITIAL_CONFIDENCE: (value: string) =>
        this.setInitialConfidence(parseFloat(value)),
      REACT_APP_INITIAL_TRANSPOSED: this.setInitialTransposed,
      REACT_APP_BACKEND_URL: this.setBackendUrl,
      REACT_APP_MULTIFILE_UPLOAD: this.setMultifileUpload,
      REACT_APP_MULTIFILE_SINGLE_REQUEST: this.setMultifileSingleRequest,
      REACT_APP_HEADER_AND_SIDEBAR: this.setHeaderAndSidebar,
      REACT_APP_LOGIN_REQUIRED: this.setLoginRequired,
      REACT_APP_SHOW_AWS_MARKETPLACE: this.setShowAWSMarketplace,
    };

    applyEnvVars(envVars, setters);
  }

  constructor() {
    makeObservable(this, {
      noModel: observable,
      syncUploader: observable,
      initialConfidence: observable,
      initialTransposed: observable,
      backendUrl: observable,
      multifileUpload: observable,
      multifileSingleRequest: observable,
      headerAndSidebar: observable,
      loginRequired: observable,
      setNoModel: action,
      setSyncUploader: action,
      setInitialConfidence: action,
      setInitialTransposed: action,
      setBackendUrl: action,
      setMultifileUpload: action,
      setMultifileSingleRequest: action,
      setHeaderAndSidebar: action,
      setLoginRequired: action,
      setShowAWSMarketplace: action,
    });
    this.setNoModel = this.setNoModel.bind(this);
    this.setSyncUploader = this.setSyncUploader.bind(this);
    this.setInitialConfidence = this.setInitialConfidence.bind(this);
    this.setInitialTransposed = this.setInitialTransposed.bind(this);
    this.setBackendUrl = this.setBackendUrl.bind(this);
    this.setMultifileUpload = this.setMultifileUpload.bind(this);
    this.setMultifileSingleRequest = this.setMultifileSingleRequest.bind(this);
    this.setHeaderAndSidebar = this.setHeaderAndSidebar.bind(this);
    this.setLoginRequired = this.setLoginRequired.bind(this);
    this.setShowAWSMarketplace = this.setShowAWSMarketplace.bind(this);
    this.fetchEnvVars();
  }
}

export const envVarStore = new EnvVarStore();
